import { useState } from "react";
import { getDocFormFiller } from "Services/docForm.service";
import {
	deriveInitialsFromName,
	getSignerDisplayNameFromStorage,
} from "../utils/initials";
import {
	checkboxChoiceGroup,
	checkboxOptionLabel,
	isCheckboxField,
} from "../utils/checkboxChoiceGroup";

export const useDocFormFiller = () => {
	const [docFormFiller, setDocFormFiller] = useState(null);
	const [fields, setFields] = useState([]);
	const [urlPdf, setUrlPdf] = useState("");
	const [values, setValues] = useState([]);
	const [flowId, setFlowId] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);

	const getDocFormFillerData = async (id, form_request_id) => {
		setIsLoading(true);
		setError(null);
		try {
			const response = await getDocFormFiller(id, form_request_id);
			setDocFormFiller(response.data);

			if (response.data.flowId) {
				setFlowId(response.data.flowId);
			}

			// Mapear los fields para que tengan la estructura correcta
			const mappedFields = (response.data.new.form[0].fields || []).map(field => ({
				...field,
				id: field.fieldId, // Asegurar que el ID coincida
				type: field.fieldType,
				title: checkboxOptionLabel(field) || field.fieldId,
				required: field.fieldRequired || field.required || false,
				fieldRequired: field.fieldRequired || field.required || false,
				fieldGroupColor: field.fieldGroupColor || null,
			}));
			setFields(mappedFields);
			
			if (response.data.pdfUrl) {
				setUrlPdf(response.data.pdfUrl);
			} else {
				setUrlPdf(response.data.doc.thumbnail);
			}
			// Inicializa values como array de objetos con la estructura deseada
			const signerName = getSignerDisplayNameFromStorage();
			const initialValues = (response.data.new.form[0].fields || []).map(field => {
				let value = field.fieldValue ?? field.value ?? "";
				if (
					field.fieldType === "initials" &&
					field.autoGenerateInitials &&
					!(value || "").toString().trim()
				) {
					value = deriveInitialsFromName(signerName);
				}
				if (isCheckboxField(field)) {
					const v = (value || "").toString().trim().toLowerCase();
					value =
						v === "true" || v === "yes" || v === "1" || v === "selected" || v === ":selected:" || v === "checked"
							? "true"
							: "false";
				}
				return {
					id: field.fieldId,
					label: checkboxOptionLabel(field) || field.fieldId,
					placeholder: field.placeholder || "",
					value,
					fieldType: isCheckboxField(field) ? "checkbox" : field.fieldType,
					fieldRequired: field.fieldRequired || field.required || false,
					fieldGroupTitle: field.fieldGroupTitle || field.fieldGroup || "",
					choiceGroup: checkboxChoiceGroup(field),
					autoGenerateInitials: Boolean(field.autoGenerateInitials),
				};
			});
			setValues(initialValues);
		} catch (err) {
			console.error("Error fetching doc form filler:", err);
			setError(err);
			throw err;
		} finally {
			setIsLoading(false);
		}
	};

	// const rejectDocForm = async (id) => {
	// 	try {
	// 		await docFormFillerService.rejectDocForm(id);
	// 	} catch (error) {
	// 		console.error("Error rejecting doc form:", error);
	// 		throw error;
	// 	}
	// };

	// const completeDocForm = async (id) => {
	// 	try {
	// 		await docFormFillerService.completeDocForm(id);
	// 	} catch (error) {
	// 		console.error("Error completing doc form:", error);
	// 		throw error;
	// 	}
	// };

	// const updateField = async (fieldId, value) => {
	// 	try {
	// 		await docFormFillerService.updateField(fieldId, value);
	// 		setFields(prevFields => 
	// 			prevFields.map(field => 
	// 				field.id === fieldId ? { ...field, value } : field
	// 			)
	// 		);
	// 	} catch (error) {
	// 		console.error("Error updating field:", error);
	// 		throw error;
	// 	}
	// };

	// Permite actualizar el valor de un campo por id
	const setValue = (fieldId, value) => {
		setValues(prev => prev.map(f =>
			String(f.id) === String(fieldId) ? { ...f, value } : f
		));
	};

	return {
		docFormFiller,
		setDocFormFiller,
		getDocFormFillerData,
		fields,
		urlPdf,
		values,
		setValue,
		flowId,
		isLoading,
		error,
	};
};
